import { AdsList } from '../pages/AdsManagement/AdsList'
import { BannerList } from '../pages/Banner/BannerList'
import { BeadsList } from '../pages/BeadsManager/BeadsList'
import { BlogList } from '../pages/Blog/BlogList'
import { CountryList } from '../pages/Country/CountryList'
import { Dashboard } from '../pages/Dashboard'
import { EffectsList } from '../pages/Effects/EffectsList'
import { EmailList } from '../pages/Email/EmailList'
import { PackagesList } from '../pages/InAppPurchase/PackagesList'
import { FaqList } from '../pages/FAQ/FaqList'
import { FilterList } from '../pages/Filter/FilterList'
import { FontStyleList } from '../pages/FontStyle/FontStyleList'
import { GeoLocationList } from '../pages/GeoLocation/GeoLocationList'
import { GlobalSettingList } from '../pages/GlobalSetting/GlobalSettingList'
import { Login } from '../pages/Login'
import { NotificationList } from '../pages/Notification/NotificationList'
import { EditProfile } from '../pages/Profile/EditProfile'
import { RateList } from '../pages/Rate/RateList'
import { ReportAbuseList } from '../pages/ReportAbuse/ReportAbuseList'
import { RoleList } from '../pages/Role/RoleList'
import { SoundList } from '../pages/Sound/SoundList'
import { StateList } from '../pages/StateManager/StateList'
import { StaticList } from '../pages/Static/StaticList'
import { StickerList } from '../pages/Sticker/StickerList'
import { StreamingList } from '../pages/Streaming/StreamingList'
import { SubAdminList } from '../pages/SubAdmin/SubAdminList'
import { TagsList } from '../pages/Tags/TagsList'
import { TransactionList } from '../pages/Transaction/TransactionList'
import { UserDetails } from '../pages/User/UserDetails'
import UserFullDetails from "../pages/User/UserFullDetails";
import { UserList } from '../pages/User/UserList'
import { UserLocationAnalytics } from '../pages/User/UserLocationAnalytics'
import { VideoList } from '../pages/Video/VideoList'
import { VideoCountByLanguage } from '../pages/Video/VideoCountByLanguage'
import { WidgetList } from '../pages/Widget/WidgetList'
import { WithdrawList } from '../pages/Withdraw/WithdrawList'
import { CityList } from '../pages/CityManager/CityList'
import { DistrictList } from '../pages/DistrictManager/DistrictList'
import { LanguageList } from '../pages/Language/LanguageList'
import { InfluencerList } from '../pages/Influencer/InfluencerList'
import { InfluencerCategoryList } from '../pages/InfluencerCategory/InfluencerCategoryList'
import { PromoVideoList } from '../pages/PromoVideoManager/PromoVideoList'
import { EventList } from '../pages/Event/EventList'
import { EventDetails } from '../pages/Event/EventDetails'
import AllEvents from '../pages/Events/Leaderboard'
import { List } from '../pages/SpecialRewardPartcipantsRequest/List'
import { View } from '../pages/SpecialRewardPartcipantsRequest/View'
import { ClamView } from '../pages/SpecialRewardClamRequest/ClamView'
import { ClamList } from '../pages/SpecialRewardClamRequest/ClamList'
import { RewardInfoList } from '../pages/RewardInfoManagement/RewardInfoList'
import { GetHelpList } from '../pages/GetHelpManager/GetHelpList'
import { CategoryList } from '../pages/GetHelpManager/CategoryList'
import { ReferralList } from '../pages/ReferralManager/ReferralList'
import { DistributionList } from '../pages/ReferralManager/DistributionList'
import { UPIWithdrawManager } from '../pages/Withdraw/UPIWithdrawManager'
import { BankWithdrawManager } from '../pages/WithdrawBank/BankWithdrawManager'
import UserBankWithdrawHistory from '../pages/WithdrawBank/UserBankWithdrawHistory';
import ChipsWalletManager from '../pages/ChipsWalletManager/ChipsWalletManager';
import ChipsWalletTransactionHistory from '../pages/ChipsWalletManager/ChipsWalletTransactionHistory';
import CashWalletManager from '../pages/CashWalletManager/CashWalletManager';
import CashWalletTransactionHistory from '../pages/CashWalletManager/CashWalletTransactionHistory';
import ShoppingManager from '../pages/ShoppingManager/ShoppingManager';
import GradePage from '../pages/Grade/Page'
import GradeChangeLogPage from '../pages/Grade/GradeChangeLogPage'
import GradeUsersPage from '../pages/Grade/GradeUsersPage'
import { AppVersionConfigPage } from '../pages/AppVersionConfig/AppVersionConfigPage'

export const nav = [
  {
    path: '/',
    name: 'Dashboard',
    element: <Dashboard />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/edit-profile',
    name: 'Edit Profile',
    element: <EditProfile />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/role-manager',
    name: 'Role Manager',
    element: <RoleList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/promo-video-manager',
    name: 'Promo Video Manager',
    element: <PromoVideoList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/user-manager',
    name: 'User Manager',
    element: <UserList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/user-location-analytics',
    name: 'User Location Analytics',
    element: <UserLocationAnalytics />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/grade-manager',
    name: 'Grade Manger',
    element: <GradePage />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/grade-change-log',
    name: 'Grade Change Log',
    element: <GradeChangeLogPage />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/users-by-grade/:gradeId',
    name: 'Grade Users',
    element: <GradeUsersPage />,
    isMenu: false,
    isPrivate: true
  },
  {
    path: '/get-help-manager',
    name: 'Get Help Manager',
    element: <GetHelpList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/referral-manager',
    name: 'Referral Manager',
    element: <ReferralList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/get-help-category-manager',
    name: 'Get Help Category Manager',
    element: <CategoryList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/invited-users-manager/:referralCode',
    name: 'Invited User Manager',
    element: <UserList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/user-manager/:id',
    name: 'User Details Manager',
    element: <UserDetails />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/user-manager-d/:id',
    name: 'User Details Manager',
    element: <UserFullDetails />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/inviter-manager',
    name: 'Event Details Manager',
    element: <AllEvents />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/event-manager/:id',
    name: 'Event Details Manager',
    element: <EventDetails />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/sub-admin-manager',
    name: 'Sub Admin Manager',
    element: <SubAdminList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/filter-manager',
    name: 'Filter Manager',
    element: <FilterList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/font-style-manager',
    name: 'Font & Style Manager',
    element: <FontStyleList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/effect-manager',
    name: 'Effect Manager',
    element: <EffectsList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/sound-manager',
    name: 'Sound Manager',
    element: <SoundList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/widget-manager',
    name: 'Widgets Manager',
    element: <WidgetList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/report-abuse-manager',
    name: 'Report Abuse Manager',
    element: <ReportAbuseList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/beads-purchase-manager',
    name: 'Chips Purchase Manager',
    element: <BeadsList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/video-manager',
    name: 'Video Manager',
    element: <VideoList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/video-manager/language-count',
    name: 'Video Count By Language',
    element: <VideoCountByLanguage />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/distribution-list',
    name: 'Distribution List',
    element: <DistributionList />,
    isMenu: false,
    isPrivate: true
  },
  {
    path: '/streaming-manager',
    name: 'Video Manager',
    element: <StreamingList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/transaction-manager',
    name: 'Transaction Manager',
    element: <TransactionList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/app_packages-manager',
    name: 'In App Packages Manager',
    element: <PackagesList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/notification-manager',
    name: 'Notification Manager',
    element: <NotificationList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/country-manager',
    name: 'Country Manager',
    element: <CountryList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/state-manager',
    name: 'State Manager',
    element: <StateList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/city-manager',
    name: 'City Manager',
    element: <CityList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/district-manager',
    name: 'District Manager',
    element: <DistrictList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/email-manager',
    name: 'Email Manager',
    element: <EmailList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/app-version-config-manager',
    name: 'App Version Config',
    element: <AppVersionConfigPage />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/global-setting-manager',
    name: 'Global Setting Manager',
    element: <GlobalSettingList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/static-content-manager',
    name: 'Static Content Manager',
    element: <StaticList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/geo-location-manager',
    name: 'Geo Location Manager',
    element: <GeoLocationList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/ads-manager',
    name: 'Ads Manager',
    element: <AdsList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/blog-manager',
    name: 'Blog Manager',
    element: <BlogList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/tag-manager',
    name: 'Tags Manager',
    element: <TagsList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/influencer-category-manager',
    name: 'Influencer Category Manager',
    element: <InfluencerCategoryList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/language-manager',
    name: 'Language Manager',
    element: <LanguageList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/influencer-manager',
    name: 'Influencer Manager',
    element: <InfluencerList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/special-reward-manager',
    name: 'Special Reward Manager',
    element: <List />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/special-reward-manager/:id',
    name: 'Special Reward Request Details Manager',
    element: <View />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/special-reward-clam-manager',
    name: 'Special Reward Clam Manager',
    element: <ClamList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/special-reward-clam-manager/:id/:userId',
    name: 'Special Reward Clam Details Manager',
    element: <ClamView />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/faq-manager',
    name: 'FAQ Manager',
    element: <FaqList />,
    isMenu: true,
    isPrivate: true
  },
  // {
  //   path: '/rating-manager',
  //   name: 'Rate Application Manager',
  //   element: <RateList />,
  //   isMenu: true,
  //   isPrivate: true
  // },
  {
    path: '/withdraw-manager',
    name: 'Withdraw Manager',
    element: <WithdrawList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/banner-manager',
    name: 'Banner Manager',
    element: <BannerList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/reward-info-manager',
    name: 'Reward Info Manager',
    element: <RewardInfoList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/event-manager',
    name: 'Event Manager',
    element: <EventList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/meishe-assets-manager',
    name: 'Meishe Assets',
    element: <StickerList />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/login',
    name: 'Login',
    element: <Login />,
    isMenu: true,
    isPrivate: false
  },
  {
    path: '/upi-withdraw-manager',
    name: 'UPI Withdraw Manager',
    element: <UPIWithdrawManager />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/bank-withdraw-manager',
    name: 'Bank Withdraw Manager',
    element: <BankWithdrawManager />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/user-bank-withdraw-history/:userId',
    name: 'User Bank Withdraw History',
    element: <UserBankWithdrawHistory />,
    isMenu: false,
    isPrivate: true
  },
  {
    path: '/chips-wallet-manager',
    name: 'Chips Wallet Manager',
    element: <ChipsWalletManager />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/cash-wallet-manager',
    element: <CashWalletManager />,
    name: 'Cash Wallet Manager',
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/view-cash-wallet-history',
    name: 'Cash Wallet Transaction History',
    element: <CashWalletTransactionHistory isStandalonePage={true} />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/view-chips-wallet-history',
    name: 'Chip Wallet Transaction History',
    element: <ChipsWalletTransactionHistory isStandalonePage={true} />,
    isMenu: true,
    isPrivate: true
  },
  {
    path: '/shopping-manager',
    name: 'Shopping Manager',
    element: <ShoppingManager />,
    isMenu: true,
    isPrivate: true
  }
]
